/**
 * Who caught the failure, written on the crash's `Handler:` line. `Error` and `UnhandledRejection` are the
 * Bugfender SDK's own names for its window listeners, so a failure caught before the SDK listens lands in the
 * same crash group as one the SDK catches later.
 */
export enum CrashHandler {
	Error = 'Error',
	UnhandledRejection = 'UnhandledRejection',
	Bootstrap = 'Bootstrap',
	Angular = 'Angular',
}
